import { Button, Row, useTheme } from "@commonlibs";
import clsx from "clsx";
import { spacing } from "ui/config/theme/spacing/spacing";
import useTranslate from "ui/locale/hooks/useTranslate";
import { ModalFooterProps } from "./ModalFooter.types";

const ModalFooter = ({
    className,
    style,
    cancel = true,
    onCancel,
    cancelLabel,
    isLoading,
    mainLabel,
    mainType,
    onSubmit,
    disabled,
}: ModalFooterProps) => {
    const translate = useTranslate();
    const theme = useTheme();
    return (
        <Row
            className={clsx("modal-footer", className)}
            gap={spacing["6"]}
            style={style}
            justifyContent="space-between"
            alignItems="center"
            breakpoint={{ width: theme.breakpoints.values.mobile, gap: spacing["3"] }}
        >
            {cancel && (
                <Button variant="outlined" fullWidth onClick={onCancel} disabled={isLoading}>
                    {cancelLabel || translate("cancel")}
                </Button>
            )}
            <Button disabled={disabled} variant="primary" fullWidth type={mainType} loading={isLoading} onClick={onSubmit}>
                {mainLabel || translate("continue")}
            </Button>
        </Row>
    );
};

export default ModalFooter;
